module.exports = "/_next/static/images/ManageYourRiskExposure@3x-5b299de17c948108d4688e2b15663ea1.webp";